export default __webpack_public_path__ + "static/media/pin.3c3501d0.png";